import React, { useState } from 'react';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Box, Button, Card, CardContent, Grid, InputAdornment, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { InfoOutlineRounded } from '@mui/icons-material';
import LinkIcon from '@mui/icons-material/Link';
import HowToPlayDialog from './components/HowToPlay/HowToPlayDialog';
import FAQDialog from './components/FAQ/FAQDialog';
import { Game, getGames } from './components/Game.helpers';
import GamePlay from './components/Gameplay/GamePlay';
import StatsDialog from './components/Stats/StatsDialog';
import useIsMobile from './components/App.helper';

const theme = createTheme({
  // Customize your theme here
  palette: {
    mode: 'light',
    primary:{
      main: '#1B2838'
    },
    secondary:{
      main: '#C7D5E0',
      contrastText: '#66C0F4'
    },
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: [
      'League Gothic',
    ].join(','),
  },
});

function App() {
  const [howToPlayOpen, setHowToPlayOpen] = useState<boolean>(false)
    const [FAQOpen, setFAQOpen] = useState<boolean>(false)
    const [StatsOpen, setStatsOpen] = useState<boolean>(false)
    const [username, setUsername] = useState('')
    const [games, setGames] = useState<Game[]>()
    const isMobile = useIsMobile()

  
  const handleHowToPlayOpen= ()=>{
    setHowToPlayOpen(!howToPlayOpen)
  }

  const handleFAQOpen= ()=>{
    setFAQOpen(!FAQOpen)
  }

  const handleStatsOpen = () =>{
    setStatsOpen(!StatsOpen)
  }
  const goToCompanyURL=()=>{
      const newWindow = window.open('https://buymeadrinkfirst.uk/', '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
  }

  const handleUsernameSearch = async() => {
    if(username) {
      try {
        let name = ''
          if(username.includes('/')) {
            name = username.split("/")[4];
          } else{
            name = username
          }
          setGames(await getGames(name))
      } catch (error) {
        console.log(error)
      }
      }
    }
  

  return (
     <ThemeProvider theme={theme}>
    <Stack className="App" sx={{backgroundColor: theme.palette.primary.main}}>
     
      <header className="App-header">
        <Typography variant={!isMobile ?'h1':'h4'} className='scrolling-text' >KNOW YOUR STEAM</Typography>
      </header>
      <Grid mt='2rem'>
      <Card className={!isMobile ? 'fade-in-stack m-2 p-2':'fade-in-stack' } sx={{ justifySelf:'center', width:isMobile ? '80vw':'50vw'}} >
        <CardContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { mb: 2} }}
            noValidate
            autoComplete="off"
          >  
          {!games && <>
            <Stack direction={'row'} color={theme.palette.primary.main} sx={{marginTop:'1em'}}>
              <InfoOutlineRounded fontSize={!isMobile ? 'large':'small'}/>
              <Typography variant={!isMobile?'h4':'body1'} >Steam Profile URL:</Typography>
            </Stack>
            <TextField 
              placeholder='Steam Profile URL' 
              value={username}
              fullWidth 
              color={'primary'} 
              variant='outlined' 
              helperText={'Steam user must have games activity set to public'}
              slotProps={{
                input: {
                  startAdornment: <InputAdornment position="start"><LinkIcon color='inherit'/></InputAdornment>
                },
              }}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setUsername(event.target.value);
              }} 
              onKeyPress={(e) => { if (e.key === "Enter") {
                e.preventDefault()
                handleUsernameSearch()} }}
            ></TextField>
            <Button variant='outlined' size={!isMobile ? 'large':'small'} color={'primary'} sx={{marginTop:!isMobile?'1em':'0'}} onClick={handleUsernameSearch} >Let's Go!</Button>
            </>
            }
            {games && <GamePlay games={games}></GamePlay>}

            <Stack direction={'row'} spacing={4} sx={{ justifySelf:'center', marginTop:'1em'}}>
              <Button variant='text' size={!isMobile ? 'large':'small'} onClick={handleHowToPlayOpen}> How to play</Button>
              <Button variant='text' size={!isMobile ? 'large':'small'} onClick={handleFAQOpen}> FAQ</Button>
              <Button variant='text' size={!isMobile ? 'large':'small'} onClick={handleStatsOpen}> Stats</Button>
            </Stack>
          </Box>
          </CardContent>
        </Card>
 </Grid>
       <Typography variant='caption' className={'fade-in-footer'} sx={{bottom:0, color:'white','&:hover':{
              cursor:'pointer'
            }
    }} onClick={()=>{goToCompanyURL()}} >A Buy Me A Drink First Application</Typography>
    </Stack>
    <HowToPlayDialog open={howToPlayOpen} handleClose={handleHowToPlayOpen}></HowToPlayDialog>
    <FAQDialog open={FAQOpen} handleClose={handleFAQOpen}></FAQDialog>
    <StatsDialog open={StatsOpen} handleClose={handleStatsOpen}></StatsDialog>
    </ThemeProvider>
  );
}

export default App;
